import React = require('react')
import { HttpResult, none, some } from 'widgets-for-react'
import { node_parser } from '../../Shared/api/drupal/parser'
import { EventBlocks } from '../../Shared/components/Events/EventDetails/EventDetailsState'
import { EventsConfig } from '../../Shared/components/Events/EventState'
import { JumboProps } from '../../Shared/components/Jumbo/Jumbo'
import { getPage } from '../custom_api/api'
import { activityDetailPage, generalContentPageBlocks } from '../custom_api/drupal_node_conversion'
import { BlockRenderer } from '../custom_components/components/block_renderer'
import { Jumbo } from '../custom_components/components/jumbo'
import { ActivityDetailPage } from '../custom_components/pages/activity_detail_page'

export const fetchEventsOverviewJumboGeneric: (size: JumboProps['size']) => () => Promise<HttpResult<JumboProps>> = (size) => async () => {
  const page = await getPage('/activiteiten', '', () => null)
  const result: JumboProps = (page == 'error' || page == 'loading') ? fallback(size) : {
    title: page.headerTitle,
    contents: page.description,
    imageUrlSmall: page.phImageUrlSmall,
    imageUrl: page.phImageUrl,
    imageUrlLarge: page.phImageUrlLarge,
    imageAlt: page.imageAlt,
    size
  }

  return { kind: 'result', value: result, status: 200 }
}

const fallback: (size: JumboProps['size']) => JumboProps = (size) => ({
  title: 'Er is altijd iets te doen in de bibliotheek!',
  contents: 'We organiseren regelmatig leerzame én leuke (online) activiteiten voor jong en oud. Van voorlezen tot lezingen, van jeugdtheater tot workshops en iedere week verschillende films in onze filmzaal. Op deze pagina vind je de actuele agenda.',
  imageUrl: '',
  imageUrlLarge: '',
  imageAlt: '',
  size
})

export const renderGenericJumbo = (props: JumboProps) => Jumbo({...props})

export const maybeRenderCmsPage: EventsConfig['renderCustomCmsPage'] = (cmsContent: any) => {
  if (!cmsContent) return none()

    const n = node_parser(cmsContent)
    if (n.bundle != 'activity_detail') return none()
  
    return some(<ActivityDetailPage {...activityDetailPage(n, () => null) } />)
}

export const GenericEventBlocks = (props: { blocks: EventBlocks }) => <BlockRenderer blocks={generalContentPageBlocks(props.blocks, () => null)} />
